<template>
  <el-aside style="background-color: #035F62" width="250px" class="content">
    <!--侧面导航栏-->
    <el-menu  class="el-menu-vertical-demo"  background-color="#035F62" text-color="#F3F5F9" active-text-color="#79A2F5" router :collapse="isCollapse" unique-opened>
      <el-submenu index="1"   v-if="userType === '1' || userType === '2'">
        <template slot="title">
          <i class="el-icon-document"></i>
          <span class="color">创建案例数据</span>
        </template>
        <el-menu-item-group>
          <el-menu-item class="color" index="newCase">新建案例数据</el-menu-item>
          <el-menu-item class="color" index="importNAIS">导入NAIS数据</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="2" v-if="userType === '1' || userType === '2'">
        <template slot="title">
          <i class="el-icon-upload2"></i>
          <span class="color">事故再现数据</span>
        </template>
        <el-menu-item-group>
          <el-menu-item class="color" index="importPC">导入PC数据</el-menu-item>
          <el-menu-item class="color" index="importDXF">导入DXF文件</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-menu-item index="dataManage">
        <i class="el-icon-menu"></i>
        <span class="color" slot="title">数据总览</span>
      </el-menu-item>

      <el-submenu index="4">
        <template slot="title">
          <i class="el-icon-download"></i>
          <span class="color">数据导出</span>
        </template>
        <el-submenu index="4-1">
          <template slot="title">
            <i class="el-icon-download"></i>
            <span class="color">prescan建模信息导出</span>
          </template>
          <el-menu-item-group>
            <el-menu-item class="color" index="exportSearch">检索导出数据</el-menu-item>
            <el-menu-item class="color" index="exportChoose">勾选导出数据</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item-group>
          <el-menu-item class="color" index="exportEXCEL">案例信息导出</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="5" v-if="userType === '1'">
        <template slot="title">
          <i class="el-icon-date"></i>
          <span class="color">统计与分类</span>
        </template>
        <el-menu-item-group>
          <el-menu-item class="color" index="numberStatistics">系统数据统计</el-menu-item>
          <el-menu-item class="color" index="categoryCatalog">场景分类目录</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="6" v-if="userType === '1'">
        <template slot="title">
          <i class="el-icon-tickets"></i>
          <span class="color">授权管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item class="color" index="newUser">创建用户</el-menu-item>
          <el-menu-item class="color" index="userManage">管理用户</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </el-aside>
</template>

<script>
  /*引入组件通信*/
  import bus from './bus'

  export default {
    name: "aside",
    data(){
      return{
        /*是否折叠*/
        isCollapse: false,
        /*用户菜单栏权限*/
        userType:localStorage.user
      }
    },
    /*折叠控制*/
    created(){
      // 通过 Event Bus 进行组件间通信，来折叠侧边栏
      bus.$on('collapse', msg => {
        let content = document.querySelector('.content');

        if(msg == true)
        {

          this.isCollapse = true;
          this.move(content,'width',64,30);
        }
        else {
          this.move(content,'width',250,30,()=>{
            this.isCollapse = false;
          });
        }
      })
      bus.$on('color',()=>{
        let c = document.querySelectorAll('.color');
        c.forEach((item,index)=>{
          item.style.color = "#035F62";
        })
      })
    },
    methods:{
      /*自定义移动函数*/
      move(obj, attr, target, speed, callback) {
        clearInterval(obj.timer);
        let current = parseInt(this.getStyle(obj, attr));
        if(current > target) {
          speed = -speed;
        }
        obj.timer = setInterval(()=> {
          let oldValue = parseInt(this.getStyle(obj, attr));
          let newValue = oldValue + speed;
          if((speed < 0 && newValue < target) || (speed > 0 && newValue > target)) {
            newValue = target;
          }
          obj.style[attr] = newValue + "px";
          if(newValue == target) {
            clearInterval(obj.timer);
            callback && callback();
          }

        }, 30);
      },
      getStyle(obj, name) {
        if(window.getComputedStyle) {
          return getComputedStyle(obj, null)[name];
        } else {
          return obj.currentStyle[name];
        }
      }
    }
  }
</script>

<style scoped>
  .el-menu{
    border: none;
  }
  .side{
    width: 100px;
    overflow: hidden;
    z-index: -1;
    height: 100%;
  }
  .color{
    color: white;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/aside.vue